export enum ReportStatus {
    OPEN = 'open',
    SEALED = 'sealed',
}
